module.exports = __webpack_public_path__ + "img/bank.d4e99bd5.png";